import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ArticleCard from '../ArticleCard';
import BookCard from '../BookCard';
import BookCardLarge from '../BookCardLarge';
import EventCardLarge from '../EventCardLarge';
import PodcastCardLarge from '../PodcastCardLarge';
import ScholarCardLarge from '../ScholarCardLarge';
import TestimonialCard from '../TestimonialCard';
import TweetCard from '../TweetCard';

const Grid = ({ className, closing, cols = 1, intro, items, lgCols = 1, title }) => {
  const colsClass = cols === 1 ? 'grid--1-col' : `grid--${cols}-cols`;
  const lgColsClass = lgCols === 1 ? 'grid--lg-1-col' : `grid--lg-${lgCols}-cols`;
  const cards =
    items?.filter((e) =>
      [
        'article',
        'book',
        'book-card-large',
        'event-card-large',
        'scholar-card-large',
        'podcast-card-large',
        'testimonial',
        'tweet',
      ].includes(e?.card),
    ) || [];
  const hasCards = !!cards?.length;

  if (!hasCards) {
    return null;
  }

  return (
    <div
      className={classnames(
        'grid',
        { [colsClass]: colsClass },
        { [lgColsClass]: lgColsClass },
        { [`grid--${className}`]: className },
      )}
    >
      <div className='grid__container'>
        {title && (
          <div className='grid__header'>
            <div className='grid__title'>{title}</div>
          </div>
        )}
        {intro && <div className='grid__intro' dangerouslySetInnerHTML={{ __html: intro }} />}
        {hasCards && (
          <div className='grid__body'>
            <ul className='grid__list'>
              {cards.map((item, index) => {
                return (
                  <li className='grid__list-item' key={`grid__list-item-${index}`}>
                    {item?.card === 'article' && <ArticleCard {...item} />}
                    {item?.card === 'book' && <BookCard {...item} />}
                    {item?.card === 'book-card-large' && <BookCardLarge {...item} />}
                    {item?.card === 'event-card-large' && <EventCardLarge {...item} />}
                    {item?.card === 'podcast-card-large' && <PodcastCardLarge {...item} />}
                    {item?.card === 'scholar-card-large' && <ScholarCardLarge {...item} />}
                    {item?.card === 'testimonial' && <TestimonialCard {...item} />}
                    {item?.card === 'tweet' && <TweetCard {...item} />}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {closing && <div className='grid__closing' dangerouslySetInnerHTML={{ __html: closing }} />}
      </div>
    </div>
  );
};

Grid.propTypes = {
  className: PropTypes.string,
  closing: PropTypes.string,
  cols: PropTypes.number,
  intro: PropTypes.string,
  items: PropTypes.array,
  lgCols: PropTypes.number,
  title: PropTypes.string,
};

export default Grid;
